import { BrowserRouter } from "react-router-dom";
import UserRouter from "./user/UserRouter";
import Layout from "./components/Layout";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <UserRouter />
      </Layout>
    </BrowserRouter>
  );
}

export default App;
